import script from "./SubscriptionMainBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionMainBlock.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionMainBlock.vue?vue&type=style&index=0&id=64bc8ef2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64bc8ef2"]])

export default __exports__